function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cn from 'classnames';
import map from 'lodash/map';
import get from 'lodash/get';
import DropdownIcon from 'svg/dropdown.svg';
import App from 'modules/App';
import Modal from 'components/Modal';
import Button from 'components/Form/Button';
import Account from 'modules/Account';
import MetricConversions from 'libs/MetricConversions';
import * as constants from '../../constants';
import messages from '../../messages';
import { getEmptyResult, getLabelForResultType, getResultsOfType } from '../../helpers';
import Hcp from '../../../Hcp';
import styles from './AdditionalMeasurementsModal.pcss';
var _React_PureComponent;
/* eslint-disable jsx-a11y/control-has-associated-label */ class AdditionalMeasurementsModal extends (_React_PureComponent = React.PureComponent) {
    onDropdownClick(type) {
        const isExpanded = get(this.state, `${type}.isExpanded`);
        this.setState({
            [type]: {
                isExpanded: !isExpanded
            }
        });
    }
    renderTableHeaders() {
        return /*#__PURE__*/ _jsx("thead", {
            children: /*#__PURE__*/ _jsxs("tr", {
                className: styles.additionalMeasurementsModal__tableHead,
                children: [
                    /*#__PURE__*/ _jsx("th", {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.name))
                    }),
                    /*#__PURE__*/ _jsx("th", {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.latestValue))
                    }),
                    /*#__PURE__*/ _jsx("th", {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.date))
                    }),
                    /*#__PURE__*/ _jsx("th", {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.time))
                    }),
                    /*#__PURE__*/ _jsx("th", {})
                ]
            })
        });
    }
    renderSecondaryTableRow(result, type) {
        const { value, unit, date, time } = result;
        const isExpanded = get(this.state, `${type}.isExpanded`);
        return /*#__PURE__*/ _jsxs("tr", {
            className: cn(styles.additionalMeasurementsModal__secondaryTableRow, {
                [styles['additionalMeasurementsModal__secondaryTableRow--expanded']]: isExpanded
            }),
            children: [
                /*#__PURE__*/ _jsx("td", {}),
                /*#__PURE__*/ _jsxs("td", {
                    children: [
                        value,
                        " ",
                        unit
                    ]
                }),
                /*#__PURE__*/ _jsx("td", {
                    children: date
                }),
                /*#__PURE__*/ _jsx("td", {
                    children: time
                }),
                /*#__PURE__*/ _jsx("td", {})
            ]
        }, `${date}-${time}-${value}-${unit}`);
    }
    renderSecondaryTableRows(results, type) {
        return map(results, (result)=>this.renderSecondaryTableRow(result, type));
    }
    renderPrimaryTableRow(type) {
        const results = getResultsOfType(this.props.measurements, type, this.metricsConversions);
        const [latestResult, ...moreResults] = results;
        const { value, unit, date, time } = latestResult || getEmptyResult();
        const isExpanded = get(this.state, `${type}.isExpanded`);
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs("tr", {
                    className: cn(styles.additionalMeasurementsModal__primaryTableRow, {
                        [styles['additionalMeasurementsModal__primaryTableRow--expanded']]: isExpanded
                    }),
                    children: [
                        /*#__PURE__*/ _jsx("td", {
                            children: getLabelForResultType(type)
                        }),
                        /*#__PURE__*/ _jsx("td", {
                            className: styles.additionalMeasurementsModal__latestValueWrapper,
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: styles.additionalMeasurementsModal__latestValue,
                                children: [
                                    value,
                                    " ",
                                    unit
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("td", {
                            children: date
                        }),
                        /*#__PURE__*/ _jsx("td", {
                            children: time
                        }),
                        /*#__PURE__*/ _jsx("td", {
                            children: /*#__PURE__*/ _jsx(DropdownIcon, {
                                className: cn(styles.additionalMeasurementsModal__dropdown, {
                                    [styles['additionalMeasurementsModal__dropdown--expanded']]: isExpanded,
                                    [styles['additionalMeasurementsModal__dropdown--hidden']]: !moreResults.length
                                }),
                                onClick: ()=>this.onDropdownClick(type)
                            })
                        })
                    ]
                }, type),
                this.renderSecondaryTableRows(moreResults, type)
            ]
        });
    }
    renderTable() {
        return /*#__PURE__*/ _jsx("div", {
            className: styles.additionalMeasurementsModal__tableWrapper,
            children: /*#__PURE__*/ _jsxs("table", {
                className: styles.additionalMeasurementsModal__table,
                children: [
                    this.renderTableHeaders(),
                    /*#__PURE__*/ _jsxs("tbody", {
                        className: styles.additionalMeasurementsModal__tableBody,
                        children: [
                            this.renderPrimaryTableRow(constants.RESULT_TYPE.SYSTOLIC_BLOOD_PRESSURE),
                            this.renderPrimaryTableRow(constants.RESULT_TYPE.DIASTOLIC_BLOOD_PRESSURE),
                            this.renderPrimaryTableRow(constants.RESULT_TYPE.LDL),
                            this.renderPrimaryTableRow(constants.RESULT_TYPE.TRIGLYCERIDES),
                            this.renderPrimaryTableRow(constants.RESULT_TYPE.BMI)
                        ]
                    })
                ]
            })
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs(Modal, {
            modalId: constants.ADDITIONAL_MEASUREMENTS_MODAL,
            openModalId: this.props.openModalId,
            styleModifier: "lg",
            onClose: ()=>this.props.onCloseModal(),
            className: styles.additionalMeasurementsModal,
            children: [
                /*#__PURE__*/ _jsx("h1", {
                    className: "modal__header",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.additionalMeasurements))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.viewModeOnly))
                }),
                this.renderTable(),
                /*#__PURE__*/ _jsx(Button, {
                    className: cn('btn--primary', 'btn--filled', styles.additionalMeasurementsModal__closeButton),
                    labelMessage: messages.buttons.close,
                    onClick: this.props.onCloseModal
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.metricsConversions = new MetricConversions(props.metricsUnits);
        this.state = {
            [constants.RESULT_TYPE.SYSTOLIC_BLOOD_PRESSURE]: {
                isExpanded: false
            },
            [constants.RESULT_TYPE.DIASTOLIC_BLOOD_PRESSURE]: {
                isExpanded: false
            },
            [constants.RESULT_TYPE.LDL]: {
                isExpanded: false
            },
            [constants.RESULT_TYPE.TRIGLYCERIDES]: {
                isExpanded: false
            },
            [constants.RESULT_TYPE.BMI]: {
                isExpanded: false
            }
        };
    }
}
_define_property(AdditionalMeasurementsModal, "propTypes", {
    // Explicit props
    // Implicit props
    measurements: PropTypes.array,
    openModalId: PropTypes.string,
    metricsUnits: PropTypes.object,
    // Implicit actions
    onCloseModal: PropTypes.func
});
const mapStateToProps = ()=>(state, props)=>({
            openModalId: App.selectors.modal(state, props),
            measurements: Hcp.selectors.measurements(state),
            metricsUnits: Account.selectors.metricsUnits(state)
        });
const mapDispatchToProps = (dispatch)=>({
        onOpenModal: ()=>dispatch(App.actions.openModal(constants.ADDITIONAL_MEASUREMENTS_MODAL)),
        onCloseModal: ()=>dispatch(App.actions.closeModal())
    });
const ConnectedAdditionalMeasurementsModal = connect(mapStateToProps, mapDispatchToProps)(AdditionalMeasurementsModal);
export default withStyles(styles)(ConnectedAdditionalMeasurementsModal);
